import React from "react";
import { HomeIcon } from "../icons/icons";
import { Transition } from "../components/common";
import CreateStory from "../components/hoc/createStory";

const Home = () => {
  return (
    <Transition withbutton>
      <div className="stories__page page withbutton">
        <div className="page__text">
          <div className="page__title">Let the magic begin</div>
          <div className="page__subtitle">
            This is where you can start creating beautiful stories for your
            brand
          </div>
          <div className="page__subtitle mobile__sub">
            This is where you can start creating beautiful stories for your
            brand
          </div>
        </div>
        <div className="page__image">
          <HomeIcon />
        </div>
        <div className="page__button">
          <CreateStory>
            <div className="accent__button">Create Stories</div>
          </CreateStory>
        </div>
      </div>
    </Transition>
  );
};

export default Home;
